module.exports = __webpack_public_path__ + "media/foyer-ambience.6b6c5212.mp3";